(() => {
  const root = document.querySelector('[data-mtu-root]');
  if (!root) return;

  const loadingEl = root.querySelector('[data-mtu-loading]');
  const emptyEl = root.querySelector('[data-mtu-empty]');
  const errorEl = root.querySelector('[data-mtu-error]');
  const cards = Array.from(root.querySelectorAll('[data-mtu-card]'));

  const storeDomain = root.dataset.storeDomain || 'nutrition-su.myshopify.com';
  const apiVersion = root.dataset.apiVersion || '2025-10';
  const token = root.dataset.storefrontToken || '76d349f53add8fb2f0560350acfc089f';
  const cartBase = root.dataset.cartBase || '/cart/add';

  const params = new URLSearchParams(window.location.search);
  const itemsParam = params.get('items');

  const showState = (state) => {
    if (loadingEl) loadingEl.hidden = state !== 'loading';
    if (emptyEl) emptyEl.hidden = state !== 'empty';
    if (errorEl) errorEl.hidden = state !== 'error';

    // 'ready'の場合は全てのステータスを非表示
    if (state === 'ready') {
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
    }
  };

  const formatPrice = (amount, currencyCode) => {
    if (!amount || !currencyCode) return '価格未取得';
    try {
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: currencyCode
      }).format(Number(amount));
    } catch (e) {
      return `${amount} ${currencyCode}`;
    }
  };

  const parseItems = (raw) => {
    if (!raw) return [];
    return raw.split(',').map((chunk) => {
      const [idRaw, qtyRaw] = chunk.split(':');
      const id = (idRaw || '').trim();
      if (!/^\d+$/.test(id)) return null;
      const qty = parseInt((qtyRaw || '').trim(), 10);
      return {
        id,
        qty: Number.isFinite(qty) && qty > 0 ? qty : 1
      };
    }).filter(Boolean);
  };

  const items = parseItems(itemsParam);
  if (items.length === 0) {
    showState('empty');
    cards.forEach((card) => card.classList.add('is-hidden'));
    return;
  }

  // 表示するプランを決定
  const visiblePlans = (() => {
    if (items.length >= 3) return ['matsu', 'take', 'ume'];
    if (items.length === 2) return ['take'];
    if (items.length === 1) return ['ume'];
    return [];
  })();

  cards.forEach((card) => {
    const plan = card.getAttribute('data-plan');
    if (!visiblePlans.includes(plan)) {
      card.classList.add('is-hidden');
    }
  });

  const planItemsMap = new Map();
  cards.forEach((card) => {
    const plan = card.getAttribute('data-plan');
    if (!visiblePlans.includes(plan)) return;
    const indices = (card.getAttribute('data-indices') || '')
      .split(',')
      .map((value) => parseInt(value, 10))
      .filter((value) => Number.isFinite(value));
    const planItems = indices.map((idx) => items[idx]).filter(Boolean);
    planItemsMap.set(plan, planItems);
  });

  const buildCartUrl = (planItems) => {
    if (!planItems || planItems.length === 0) return null;
    const cartParams = new URLSearchParams();
    planItems.forEach((item, index) => {
      cartParams.append(`items[${index}][id]`, item.id);
      cartParams.append(`items[${index}][quantity]`, String(item.qty));
    });
    cartParams.append('return_to', '/cart');
    return `${cartBase}?${cartParams.toString()}`;
  };

  // カート追加ボタンの初期設定（商品情報取得前でも遷移できるようにする）
  cards.forEach((card) => {
    const plan = card.getAttribute('data-plan');
    if (!visiblePlans.includes(plan)) return;
    const planItems = planItemsMap.get(plan) || [];
    const cartButton = card.querySelector('[data-mtu-cart-button]');
    if (!cartButton) return;
    const cartUrl = buildCartUrl(planItems);
    if (!cartUrl) {
      cartButton.setAttribute('href', '#');
      cartButton.setAttribute('aria-disabled', 'true');
      return;
    }
    cartButton.setAttribute('href', cartUrl);
    cartButton.removeAttribute('aria-disabled');
  });

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-mtu-cart-button]')
      : null;
    if (!target) return;
    const card = target.closest('[data-mtu-card]');
    if (!card) return;
    const plan = card.getAttribute('data-plan');
    const planItems = planItemsMap.get(plan) || [];
    const cartUrl = buildCartUrl(planItems);
    if (!cartUrl) return;
    event.preventDefault();
    window.location.assign(cartUrl);
  }, true);

  const variantIds = Array.from(new Set(
    Array.from(planItemsMap.values()).flat().map((item) => item.id)
  ));

  // デバッグ: variant IDsを確認
  console.log('Variant IDs:', variantIds);

  // GIDをBase64に変換（Storefront APIのID形式に合わせる）
  const gidList = variantIds.map((id) => {
    const gid = `gid://shopify/ProductVariant/${id}`;
    try {
      return btoa(gid);
    } catch (e) {
      return gid;
    }
  });

  // デバッグ: GIDリストを確認
  console.log('GID List:', gidList);

  const query = `query VariantNodes($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        title
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        product {
          title
          productType
          onlineStoreUrl
          featuredImage {
            url
            altText
          }
        }
      }
    }
  }`;

  const fetchVariants = () => fetch(`https://${storeDomain}/api/${apiVersion}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({
      query,
      variables: { ids: gidList }
    })
  }).then((res) => {
    if (!res.ok) throw new Error('Storefront API request failed');
    return res.json();
  });

  showState('loading');

  fetchVariants()
    .then((payload) => {
      // デバッグ: APIレスポンスを確認
      console.log('API Response:', payload);

      if (payload?.errors?.length) {
        console.error('GraphQL errors:', payload.errors);
        throw new Error('Storefront API returned errors');
      }
      const nodes = (payload && payload.data && payload.data.nodes) || [];

      // デバッグ: nodesを確認
      console.log('Nodes:', nodes);

      const variantMap = new Map();

      nodes.forEach((node) => {
        if (!node || !node.id) return;
        const idMatch = node.id.match(/ProductVariant\/(\d+)/);
        if (!idMatch) return;
        variantMap.set(idMatch[1], node);
      });

      let missingVariants = 0;

      cards.forEach((card) => {
        const plan = card.getAttribute('data-plan');
        if (!visiblePlans.includes(plan)) return;
        const planItems = planItemsMap.get(plan) || [];
        const listEl = card.querySelector('[data-mtu-items]');
        const priceEl = card.querySelector('[data-mtu-price]');
        const originalPriceEl = card.querySelector('[data-mtu-original-price]');
        const discountEl = card.querySelector('[data-mtu-discount]');
        const cartButton = card.querySelector('[data-mtu-cart-button]');

        if (!listEl) return;
        listEl.innerHTML = '';

        let totalPrice = 0;           // 現在の価格（割引後）の合計
        let totalCompareAtPrice = 0;  // 元の価格（compareAtPrice）の合計
        let currencyCode = 'JPY';

        planItems.forEach((item) => {
          const data = variantMap.get(item.id);
          if (!data) missingVariants += 1;
          const productTitle = data?.product?.title || '商品名未取得';
          const variantTitle = data?.title || '';
          const displayName = variantTitle && variantTitle !== 'Default Title'
            ? `${productTitle} - ${variantTitle}`
            : productTitle;
          const price = data?.price?.amount;
          const compareAtPrice = data?.compareAtPrice?.amount;
          const imageUrl = data?.product?.featuredImage?.url || '';
          const imageAlt = data?.product?.featuredImage?.altText || productTitle;
          const productUrl = data?.product?.onlineStoreUrl || '';
          const productType = data?.product?.productType || '';
          currencyCode = data?.price?.currencyCode || currencyCode;

          // 現在の価格を加算
          if (price) {
            totalPrice += Number(price) * item.qty;
          }

          // 元の価格を加算（compareAtPriceがある場合はそれ、なければpriceを使用）
          if (compareAtPrice) {
            totalCompareAtPrice += Number(compareAtPrice) * item.qty;
          } else if (price) {
            totalCompareAtPrice += Number(price) * item.qty;
          }

          const li = document.createElement('li');
          li.className = 'mtu__item';

          // 商品画像のHTML
          const imageHtml = imageUrl
            ? `<img src="${imageUrl}" alt="${imageAlt}" class="mtu__item-image">`
            : '';

          // 商品情報のHTML
          const infoHtml = `
            <div class="mtu__item-info">
              <div class="mtu__item-name">${displayName}${!data ? ` <small style="color:#999">(ID: ${item.id})</small>` : ''}</div>
              ${productType ? `<div class="mtu__item-type">${productType}</div>` : ''}
              ${productUrl ? `<a href="${productUrl}" target="_blank" rel="noopener noreferrer" class="mtu__item-link">詳細を見る</a>` : ''}
            </div>
          `;

          li.innerHTML = `
            ${imageHtml}
            ${infoHtml}
            `;
          listEl.appendChild(li);
        });

        // 割引率を計算（元の価格と現在の価格から）
        const hasDiscount = totalCompareAtPrice > totalPrice;
        const discountRate = hasDiscount
          ? (totalCompareAtPrice - totalPrice) / totalCompareAtPrice
          : 0;

        // 価格表示（現在の価格 = 割引後の価格）
        if (priceEl) {
          priceEl.textContent = totalPrice
            ? formatPrice(totalPrice, currencyCode)
            : '価格未取得';
        }

        // 元の価格表示（割引がある場合のみ）
        if (originalPriceEl && hasDiscount) {
          originalPriceEl.textContent = formatPrice(totalCompareAtPrice, currencyCode);
          originalPriceEl.hidden = false;
        }

        // 割引バッジ表示（割引がある場合のみ）
        if (discountEl && hasDiscount && discountRate > 0) {
          discountEl.textContent = `${Math.round(discountRate * 100)}% OFF`;
          discountEl.hidden = false;
        }

        // カート追加URL生成（このカード専用）
        if (cartButton && planItems.length > 0) {
          const cartParams = new URLSearchParams();
          planItems.forEach((item, index) => {
            cartParams.append(`items[${index}][id]`, item.id);
            cartParams.append(`items[${index}][quantity]`, String(item.qty));
          });
          cartParams.append('return_to', '/cart');
          const cartUrl = `${cartBase}?${cartParams.toString()}`;
          cartButton.setAttribute('href', cartUrl);
          cartButton.removeAttribute('aria-disabled');

          // デバッグ: カートURLを確認
          console.log(`${plan} プランのカートURL:`, cartUrl);
        }
      });

      if (missingVariants > 0 && errorEl) {
        errorEl.textContent = `商品情報を取得できないIDが${missingVariants}件あります。オンラインストアに公開されているか、Storefront APIトークンが正しいか確認してください。`;
        showState('error');
      } else {
        showState('ready');
      }
    })
    .catch((error) => {
      console.error('Storefront API error:', error);
      if (errorEl) {
        errorEl.textContent = '商品情報の取得に失敗しました。ネットワーク接続やAPIトークンを確認してください。';
      }
      showState('error');
    });
})();
